
const angular = require('angular')
const $q = angular.injector(['ng']).get('$q')

module.exports = {
  CM_BROKER: window.CM_BROKER || {},
  has(name) {
    return this.CM_BROKER.hasOwnProperty(name)
  },
  call(name, ...args) {
    let result
    const handler = this.CM_BROKER[name]
    try {
      if (!angular.isFunction(handler)) {
        throw new Error(`Expected function in CM_BROKER.${name}, got '${handler}'`)
      }
      result = handler.apply(window.CM_BROKER, args)
    } catch (e) {
      alert(`${name} Hook Error: ` + e.message)
      // 提示后阻断后续代码执行
      throw e
    }
    return result
  },
  exec(name, ...args) { // 存在自定义则执行并返回执行结果（如果需要根据返回结果来判断执行什么操作，则在finnaly里面即可）
    return this.has(name) ? $q.resolve(this.call(name, ...args)) : $q.reject()
  }
}



// WEBPACK FOOTER //
// ./src/js/global/hook.js